module.exports = __webpack_public_path__ + "static/img/head_4.31f76842.png";